import { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { Box } from '@chakra-ui/react';

HighchartsMore(Highcharts);

const BarRaceChart = ({ data, colors, width, height, isMobile }) => {
	const [chartOptions, setChartOptions] = useState({});

	useEffect(() => {
		const categories = data.map(item => item.label);
		const values = data.map(item => item.value);

		setChartOptions({
			chart: {
				type: 'bar',
				animation: false,
				backgroundColor: 'transparent',
				spacingBottom: 20, // Add some space below the chart
				width: isMobile ? width : 600,
				height: height
				// height: 450, // Set height here
			},
			title: {
				text: null,
			},
			xAxis: {
				categories: categories,
				title: {
					text: null,
				},
				labels: {
					style: {
						color: '#333',
					},
				},
				tickWidth: 0,
			},
			yAxis: {
				min: 0,
				title: {
					text: null, // Make the axis title invisible
					style: {
						color: 'transparent',
					},
				},
				labels: {
					enabled: false, // Hide y-axis labels
				},
				tickWidth: 0, // Hide y-axis ticks
			},
			tooltip: {
				formatter: function () {
					// Добавьте нужную информацию в tooltip
					const pointData = data.find(item => item.label === this.point.name);
					return `
                    Marks: ${this.point.name}, ${pointData.percentage}<br/>
                    Addresses: ${this.y}<br/>
                `;
				},
				shared: true, // Show tooltips for multiple bars
				useHTML: true,
				backgroundColor: 'rgba(0,0,0,0.7)',
				style: {
					color: '#fff',
					padding: '10px',
					borderRadius: '5px',
				},
			},
			plotOptions: {
				bar: {
					dataLabels: {
						enabled: true,
					},
					groupPadding: 0.5, // Adjust this value to control the spacing between groups
					pointPadding: 0.1, // Decrease to ensure bars fit well
					pointWidth: !isMobile ? 30 : 20, // Adjust this width to ensure the spacing is accurate
					staggerLines: 1,
				},
				series: {
					animation: {
						duration: 1000,
						easing: 'easeOutBounce',
					},
				},
			},
			series: [
				{
					name: '', // Empty name to avoid displaying "Series 1"
					data: data.map(item => ({
						name: item.label,
						y: item.value,
						color: colors(item.label),
					})),
				},
			],
			legend: {
				enabled: false, // Disable the legend to hide series names
			},
			credits: {
				enabled: false, // This hides the Highcharts logo
			},
		});
	}, [data, colors]);

	return (
		<Box style={{ backgroundColor: 'transparent' }} ml={2} mr={2}> {/* Set your desired height here */}
			<HighchartsReact highcharts={Highcharts} options={chartOptions} height={height} width={width} />
		</Box>
	);
};

export default BarRaceChart;
